import { getCurrencySymbol } from '@angular/common';
import { CustomCurrencySymbolsInterface } from '../interfaces/custom-currency-symbols.interface';

export enum Default {
  digitsInfo = '1.2-2',
  digitsIntegerInfo = '1.0-0',
  templateInfo = '{0} {1}',
  templateSpan = '<span class="{0}">{1}</span>',
  templateSpanParentheses = '<span class="{0}">({1})</span>',
}

export enum ColorEnum {
  positive = 'positive-color',
  negative = 'negative-color',
  neutro = 'neutral-color',
  blue = 'blue-color',
  white = 'white-color',
}

export class Utils {
  // constructor(private formats: FormatsService) {}

  public static checkCustomCurrencySymbol(
    currencyCode: string,
    customCurrencySymbols: any
  ) {
    customCurrencySymbols = JSON.parse(customCurrencySymbols);
    //const _custom = this.formats.customCurrencySymbols;
    let _select: CustomCurrencySymbolsInterface[];
    if (customCurrencySymbols) {
      _select = customCurrencySymbols.filter(
        (item: CustomCurrencySymbolsInterface) => item.currency === currencyCode
      );
    }
    if (_select && _select.length > 0) {
      return _select[0].symbol;
    }

    return getCurrencySymbol(currencyCode, 'narrow');
  }

  public static isValue(
    value: number | string | null | undefined
  ): value is number | string {
    return !(
      value == null ||
      value === '' ||
      value === -10000 ||
      value !== value
    );
  }

  public static formatString(text: string, values: any[]): string {
    if (text === '') {
      return 'empty text';
    }

    let i = values.length;
    while (i--) {
      text = text.replace(/\{\{|\}\}|\{(\w+)\}/g, (m, n) => {
        if (m === '{{') {
          return '{';
        }
        if (m === '}}') {
          return '}';
        }
        return values[n];
      });
    }

    return text;
  }

  /*
  public static getTechLocale(currencyCode) {
    let locale: string;
    switch (currencyCode) {
      case 'EUR':
        locale = 'es';
        break;
      case 'GBP':
        locale = 'en';
        break;
      case 'NOK':
        locale = 'nl';
        break;
      default:
        locale = 'en';
        break;
    }

    return locale;
  }*/
}

export function TechFormatNumer(
  number: string,
  decimalSeparator: string = '.',
  groupSeparator: string = ','
): string {
  // Dividir el número en parte entera y decimal
  const parts = number.split('.');

  // Agregar el separador de grupo a la parte entera
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, groupSeparator);

  // Unir las partes con el separador decimal
  return parts.join(decimalSeparator);
}

export function TechGetDecimalInfo(
  digitsInfo: string = Default.digitsInfo
): number {
  let decimalReturn: number = 0;
  const NUMBER_FORMAT_REGEXP = /^(\d+)?\.((\d+)(-(\d+))?)?$/;

  if (digitsInfo) {
    const parts = digitsInfo.match(NUMBER_FORMAT_REGEXP);
    if (parts === null) {
      throw new Error(`${digitsInfo} is not a valid digit info`);
    }
    const minIntPart = parts[1];
    const minFractionPart = parts[3];
    const maxFractionPart = parts[5];

    decimalReturn = Number(minFractionPart);
  }

  return decimalReturn;
}
